<template>
  <b-modal
    v-model="dialog"
    title="Verified Stock Report Details"
    size="lg"
  >
    <div
      v-if="initialLoader"
      class="text-center"
    >
      <b-spinner
        label="Small Spinner"
        variant="primary"
      />
    </div>
    <b-alert
      variant="danger"
      :show="initialError ? true : false"
    >
      <div class="alert-body">
        <p>
          {{ initialError }}
        </p>
      </div>
    </b-alert>
    <b-form v-if="reportDetails && !initialLoader && !initialError">
      <b-table-simple
        responsive
        hover
        class="compact-table"
      >
        <b-tbody>
          <b-tr>
            <b-th> Date </b-th>
            <b-td> {{ formatedDate(reportDetails.date) }} </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <b-form-group label="Invoices">
        <b-table
          :items="reportDetails.invoices"
          :fields="tableFields"
          responsive="sm"
          striped
          hover
          class="compact-table1"
        >
          <template #cell(tickets)="{ item: invoice }">
            <span
              v-for="(ticket, index) in invoice.tickets"
              :key="ticket.id"
              class="font-weight-bold"
              :style="{ color: ticket.status === 'Closed' ? 'green' : 'red', cursor: 'pointer', display: 'inline-block', marginRight: '4px' }"
              @click="openTicketId = ticket.id"
            >
              {{ ticket.ticket_id }}<span v-if="index < invoice.tickets.length - 1">,</span>
            </span>
          </template>
        </b-table>
      </b-form-group>
    </b-form>

    <ticket-details
      v-if="openTicketId"
      :ticket-id="openTicketId"
      @modal-closed="openTicketId = null"
      @onDiscrepancyClose="fetchData"
    />

    <template #modal-footer="{ cancel }">
      <div class="d-flex">
        <b-button
          :disabled="initialLoader"
          @click="cancel"
        >
          Close
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import axios from 'axios'
import {
  BModal, BFormGroup, BForm, BButton, BSpinner, BTable, BTableSimple,
  BTbody, BTd, BTr, BTh, BAlert,
} from 'bootstrap-vue'
import dateMixin from '@/mixins/dateMixin'
import TicketDetails from '@/components/Tickets/SupplierTickets/TicketDetails.vue'

export default {
  components: {
    BModal,
    BFormGroup,
    BForm,
    BButton,
    BSpinner,
    BTable,
    BTableSimple,
    BTbody,
    BTd,
    BTr,
    BTh,
    BAlert,
    TicketDetails,
  },
  mixins: [dateMixin],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      reportDetails: null,
      tableFields: [
        { key: 'invoice_no', label: 'Invoice No', sortable: false },
        { key: 'supplier__identifier', label: 'Supplier', sortable: false },
        { key: 'tickets', label: 'Tickets', sortable: false },
      ],
      initialLoader: false,
      initialError: null,
      errorMessage: null,
      openTicketId: null,
    }
  },
  computed: {
    dialog: {
      get() {
        return this.$props.value
      },
      set(newVal) {
        this.$emit('input', newVal)
      },
    },
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      try {
        this.initialLoader = true
        this.initialError = null
        const { data } = await axios.get(`/stocks/verified_stock_reports/${this.$props.id}/`)
        this.reportDetails = data
      } catch (error) {
        this.initialError = error?.response?.data?.detail || 'Failed to fetch details!'
      } finally {
        this.initialLoader = false
      }
    },
  },
}
</script>
